module.exports = __webpack_public_path__ + "static/media/tw-tw.f67e9d95.svg";